import { AlertTriangle } from "lucide-react";
import { AI_OUTPUT_BANNER_BODY } from "../lib/disclaimer";

/**
 * Compact disclaimer block shown directly above (or below) an AI-generated
 * output. Use on case analyses, treatment plans, referral letters, fee
 * estimates, topology reports, etc.
 */
export default function AiOutputDisclaimer({ className = "" }) {
  return (
    <div
      data-testid="ai-output-disclaimer"
      role="note"
      className={`flex items-start gap-2.5 p-3 rounded-md border border-amber-500/30 bg-amber-500/10 text-[11px] sm:text-xs text-amber-200/90 leading-snug ${className}`}
    >
      <AlertTriangle size={14} className="text-amber-400 mt-0.5 shrink-0" aria-hidden="true" />
      <span>{AI_OUTPUT_BANNER_BODY}</span>
    </div>
  );
}
